import { render } from "./ShowProject.vue?vue&type=template&id=a516fd34"
import script from "./ShowProject.vue?vue&type=script&lang=js"
export * from "./ShowProject.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__